import { render, staticRenderFns } from "./DiaryLuck.vue?vue&type=template&id=c63c5a92&scoped=true&"
import script from "./DiaryLuck.vue?vue&type=script&lang=js&"
export * from "./DiaryLuck.vue?vue&type=script&lang=js&"
import style0 from "./DiaryLuck.vue?vue&type=style&index=0&id=c63c5a92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63c5a92",
  null
  
)

export default component.exports